// extracted by mini-css-extract-plugin
export default {"SignUpPage":"SignUpPage_SignUpPage__h6FFn","formWrapper":"SignUpPage_formWrapper__I42hL","logo":"SignUpPage_logo__fFAqs"};